import categories from "./categories";
import displays from "./displays";
import exhibitions from "./exhibitions";
import inquires from "./inquires";
import islands from "./islands";
import orders from "./orders";
import regularOrders from "./regular-orders";
import products from "./products";
import reviewImages from "./review-images";
import reviews from "./reviews";
import shippings from "./shippings";

export default {
    categories,
    displays,
    exhibitions,
    inquires,
    islands,
    orders,
    regularOrders,
    products,
    reviewImages,
    reviews,
    shippings,
};
